<div id="{{id}}" class="table-container jbm-table" [class.table-absolute]="absolute" [class.table-responsive]="responsive">
   <table class="table jbm-table {{classname}}" [style.width]="fullWidth ? '100%' : 'auto'"
      [class.table-hover]="hoverable" [class.table-row-selectable]="rowSelectable" [class.table-striped]="striped"
      [class.table-bordered]="bordered" [class.table-sm]="size=='sm'" [class.table-xs]="size=='xs'">
      <jbm-table-header [columnDefs]="columnDefs" [actionDefs]="actionDefs" [actionsColumnWidth]="actionsColumnWidth"
         [sortable]="sortable" [sortDirection]="sortDirection" [hideHeader]="hideHeader"
         (sortChange)="tableSortChange($event)" (columnDefsChange)="tableColumnDefsChange($event)">
      </jbm-table-header>
      <tbody>
         <tr *ngIf="filterable && showFilters" class="table-filters">
            <ng-container *ngFor="let c of columnDefs">
               <td *ngIf="c.type==ColType.panelToggle" class="table-row-expand">&nbsp;</td>
               <td *ngIf="c.type!=ColType.panelToggle" [hidden]="!c.visible">
                  <jbm-table-column-filter *ngIf="c.filterable" [name]="c.name" [columnType]="c.type" [IDName]="c.IDName"
                     [filterValues]="c.filterValues" [filterValue]="c.filterValue" [searchMinLength]="c.searchMinLength"
                     (filterChange)="tableFilterChange($event)">
                  </jbm-table-column-filter>
               </td>
            </ng-container>
            <td *ngIf="actionDefs.length">&nbsp;</td>
         </tr>
         <ng-container *ngFor="let row of data">
            <tr (click)="onRowSelect(row)" [ngClass]="{selected: highLightSelectedRow && selectedRowId>-1 && selectedRowId===row.id}">
               <ng-container *ngFor="let c of columnDefs">
                  <ng-container [ngSwitch]="c.type">
                     <td *ngSwitchCase="ColType.id" [hidden]="true" jbm-table-cell [data]="row.id"></td>
                     <td *ngSwitchCase="ColType.notes" [hidden]="!c.visible" class="comments {{c.className}}">
                        <jbm-comments-dropdown [iconClass]="c.iconClassname" [comments]="row[c.name]"
                           [extraSmall]="size=='xs'" (onOpenChange)="openDropdownChange($event)">
                        </jbm-comments-dropdown>
                     </td>
                     <td *ngSwitchCase="ColType.address" [hidden]="!c.visible" class="address {{c.className}}">
                        <jbm-address-dropdown [address_details_id]="row[c.name]" [extraSmall]="size=='xs'"
                           [class]="'btn-block'" (onOpenChange)="openDropdownChange($event)">
                        </jbm-address-dropdown>
                     </td>
                     <td *ngSwitchCase="ColType.panelToggle" class="expandable {{c.className}}">
                        <button *ngIf="isExpandable(row)" [class.active]="rowExpanded==row.id"
                           class="btn btn-light btn-block"
                           [ngbTooltip]="rowExpanded==row.id ? rowCollapseTooltip : rowExpandTooltip"
                           container="body"
                           [ngClass]="{'btn-xs': size=='xs', 'btn-sm': size=='sm'}"
                           (click)="toggleRowExpanded(row); $event.stopPropagation()">
                           <i class="fa" [class.fa-plus]="rowExpanded!=row.id" [class.fa-minus]="rowExpanded==row.id"></i>
                           <span *ngIf="c.header">&nbsp;{{c.header}}</span>
                        </button>
                     </td>
                     <td *ngSwitchCase="ColType.stringAndID && !c.template" [hidden]="!c.visible" jbm-table-cell [type]="c.type"
                        [align]="c.align" [data]="row[c.name]" [idValue]="row[c.IDName]" [stringIDdisplay]="stringIDdisplay" 
                        [displayValues]="c.displayValues" class="{{c.className}}">
                     </td>
                     <td *ngSwitchCase="ColType.stringAndID && c.template" [hidden]="!c.visible" class="{{c.className}}">
                        <ng-container *ngTemplateOutlet="c.template; context: { 'data': row }"></ng-container>
                     </td>
                     <ng-container *ngSwitchDefault>
                        <td *ngIf="c.template" [hidden]="!c.visible" class="{{c.className}}">
                           <ng-container *ngTemplateOutlet="c.template; context: { 'data': row }"></ng-container>
                        </td>
                        <td *ngIf="!c.template" [hidden]="!c.visible" jbm-table-cell [type]="c.type"
                           [align]="c.align" [data]="row[c.name]" [idValue]="row[c.IDName]" [stringIDdisplay]="stringIDdisplay" 
                           [displayValues]="c.displayValues" class="{{c.className}}">
                        </td>
                     </ng-container>
                  </ng-container>
               </ng-container>
               <td *ngIf="actionDefs.length" class="actions">
                  <span *ngFor="let a of actionDefs" jbm-table-action [name]="a.name" [iconClass]="a.iconClass"
                     [caption]="a.caption" [size]="size" [context]="a.context"
                     (click)="onActionClick(row,a.name); $event.stopPropagation()">
                  </span>
               </td>
            </tr>
            <tr *ngIf="template && rowExpanded==row.id" class="table-row-expanded">
               <td [colSpan]="visibleColumnCount()" class="expanded">
                  <ng-container *ngTemplateOutlet="template; context: { 'data': row }"></ng-container>
               </td>
            </tr>
         </ng-container>
      </tbody>
   </table>
   <div *ngIf="data && !data.length" class="jbm-empty-view">{{'ui.empty-view'|translate}}</div>
</div>